import { takeEvery, takeLatest } from 'redux-saga/effects';
import { NOTIFICATION_LIST_FETCH, NOTIFICATION_READ_FETCH } from '../constants';
import { notificationListSaga, notificationReadSaga } from './notificationSagas';

export function* rootNotificationSaga() {
  yield takeLatest(NOTIFICATION_LIST_FETCH, notificationListSaga);
  yield takeEvery(NOTIFICATION_READ_FETCH, notificationReadSaga);
}
